import { Link } from "@mui/material";
import { Shipment } from "../../../graphql/generated";
import { formatShipmentLabel } from "../../../utils/labels/shipmentLabel";
import { testIds } from "./ShipmentLink.testIds";

type ShipmentLinkProps = {
  shipment: Pick<
    Shipment,
    | "_id"
    | "shipmentNumber"
    | "referenceNumbers"
    | "isFromSplit"
    | "isFromRotation"
  > & {
    parentShipment?: Pick<
      Exclude<Shipment["parentShipment"], null | undefined>,
      "_id"
    > | null;
  };
};

const ShipmentLink = ({ shipment }: ShipmentLinkProps) => {
  return (
    <Link data-testid={testIds.shipmentLinkOpen}
      onClick={(e) => e.stopPropagation()}
      href={`/orders/details/${shipment._id}`}
      sx={{
        textTransform: "capitalize",
      }}
      target="_blank"
    >
      {formatShipmentLabel(shipment)}
    </Link>
  );
};

export default ShipmentLink;
